<template>
    <div id="app" class="container">
        <div v-if="ready">
            <Intro v-if="page === 'intro'"></Intro>
            <Question v-if="typeof page == 'number'"></Question>
            <Gate v-if="page === 'gate'"></Gate>
            <Result v-if="page === 'result'"></Result>
            <Contact v-if="page === 'contact'"></Contact>
        </div>
        <div v-else class="loading-screen row justify-content-center">
            <div class="col-2">
                <div class="loader">
                    <span class="loader__progress">&nbsp;</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Intro, Question, Gate, Result} from './components/pages'
    import AnswerPreload from './services/AnswerPreload';

    export default {
        name: 'app',
        components: {
            Intro,
            Question,
            Gate,
            Result,
        },
        computed: {
            page() {
                return this.$store.state.current;
            },
            ready() {
                return this.$store.state.ready;
            }
        },
        created() {
            this.$store.commit("setUrl", window.location.href.split('?')[0]);
            let isPreload = AnswerPreload.checkPreload(this.$store);
            this.$store.dispatch('loadQuestions', isPreload);
        }
    }
</script>

<style lang="stylus" scoped>
    body
        font-size 1.8rem !important

        #app
            .loader
                display flex
                position fixed
                z-index 100
                top 0
                left 0
                width 100vw
                height 100vh
                justify-content center
                align-items center
                background-color $color-white
                transition all .3s

                &__progress
                    width 10rem
                    height 10rem
                    border 5px solid $color-blue-petrol
                    border-left-color transparent
                    border-radius 50%
                    animation rotate 1.5s linear infinite

                @-webkit-keyframes rotate
                    from
                        -webkit-transform rotate(0deg)
                    to
                        -webkit-transform rotate(360deg)
</style>
